export default __webpack_public_path__ + "static/media/vampyricnature.520f031f.png";